// extracted by mini-css-extract-plugin
module.exports = {"capacityInput":"reservedCapacity_capacityInput__3fsEK","periodCol":"reservedCapacity_periodCol__1u9U7","typeCol":"reservedCapacity_typeCol__1i0Sg"};